import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {SubscribersService, TokenStorageService} from '@coreServices';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ConfirmModalComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() confirmationButtonText?: string = "Confirm";
  @Input() cancelButtonText?: string = "Cancel";
  @Input() isDeactivateAccount !: any
  @Input() isAlert!: boolean;

  constructor(public activeModal: NgbActiveModal,
              private tokenStorageService: TokenStorageService,
              private subscriberService: SubscribersService,
              public router: Router,
  ) {
  }

  clearToken() {
    this.activeModal.close();
    this.tokenStorageService.clearStorage();
    this.subscriberService.isUserLoggedIn.next(false);
    this.router.navigate(['/']);
  }
}
